import { parseDate } from '../helpers/date';
import { DjangoTimeStamped, TimeStamped } from './../django';
import { Loan } from './../loan';
import { parseProposal, Proposal } from './../proposal';
import { parseLoan } from './loan.model';

export class LoanRenegotiation implements TimeStamped {
  id: string;
  loan: Loan;
  proposal: Proposal;
  // TIME STAMPED
  created: Date;
  modified: Date;

  constructor(data: string | LoanRenegotiation | DjangoLoanRenegotiation = {}) {
    if (data instanceof LoanRenegotiation) {
      bindLoanRenegotiationData(this, data);
    } else if (typeof data === 'string') {
      bindDjangoLoanRenegotiationData(this, { id: data });
    } else {
      bindDjangoLoanRenegotiationData(this, data);
    }
  }
}

export function parseLoanRenegotiation(data: DjangoLoanRenegotiation | LoanRenegotiation) {
  if (data) {
    return new LoanRenegotiation(data);
  } else {
    return undefined;
  }
}

function bindLoanRenegotiationData(loan: LoanRenegotiation, data: LoanRenegotiation) {
  loan.id = data.id;
  loan.loan = data.loan;
  loan.proposal = data.proposal;
  // TIME STAMPED
  loan.created = data.created;
  loan.modified = data.modified;
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoLoanRenegotiation extends DjangoTimeStamped {
  id?: string;
  loan?: string;
  proposal?: string;
  // TIME STAMPED
  created?: string;
  modified?: string;
}

function bindDjangoLoanRenegotiationData(loan: LoanRenegotiation, data: DjangoLoanRenegotiation) {
  loan.id = data.id;
  loan.loan = parseLoan(data.loan);
  loan.proposal = parseProposal(data.proposal);
  // TIME STAMPED
  loan.created = parseDate(data.created);
  loan.modified = parseDate(data.modified);
}
